import { RemoteCollectionStore } from "@softline/core";
import { OffenerPosten } from "../types/offener-posten";

export const OffenePostenStore = RemoteCollectionStore.create<OffenerPosten>();

export const JopostenStore = RemoteCollectionStore.create<OffenerPosten>();
